"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchoringTransactionSchema = void 0;
const buffer_1 = require("buffer");
const zod_1 = require("zod");
const txRid_1 = require("./txRid");
exports.AnchoringTransactionSchema = zod_1.z.object({
    txRid: zod_1.z.instanceof(buffer_1.Buffer).superRefine((rid, refCtx) => {
        const txRidValidation = txRid_1.TxRidSchema.safeParse(rid);
        if (!txRidValidation.success)
            txRidValidation.error.issues.forEach(issue => refCtx.addIssue(issue));
    }),
    txData: zod_1.z.instanceof(buffer_1.Buffer).refine(data => data.length > 0, {
        message: "txData must be a non-empty Buffer",
    }),
    txOpIndex: zod_1.z.number().int().nonnegative({ message: "txOpIndex must be a non-negative integer" }),
});
//# sourceMappingURL=anchoringTransaction.js.map